import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
import { InstanceInfoViewComponent } from '../instance-info-view/instance-info-view.component';
declare var $;
@Component({
  selector: 'app-instance-select',
  templateUrl: './instance-select.component.html',
  styleUrls: ['./instance-select.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InstanceSelectComponent),
    multi: true
  }]
})
export class InstanceSelectComponent implements ControlValueAccessor {

  /**
   * 输出属性,下拉框选中某一项之后,将选中对象传递给父组件
   */
  @Output() changeClick = new EventEmitter();
  // 所属概念id
  @Input() conceptId: string
  // 是否禁止操作
  @Input() disabledValue:boolean = false;
  // 是否允许新增实体
  @Input() addEnable = false;
  @Input() placeholder = '';
  // 查询关键字实体名称
  filter:string = '';
  // 查询到的实体列表数据
  datas:any = [];
  // 当前选择的实体信息
  selectNode:any = {}
  // 是否展示下拉框
  showDropBox = false;
  constructor(
    private instanceModuleService: InstanceModuleService,
    private jwt: SwJwtService,
    private create:SwCreateModalComponentService,
    private kmsService: KmsService,
    private box: SwMassageBoxService
  ) { }
  _data: any;

  // 先定义一个方法，很重要，用于接收registerOnChange()方法里传递回来的方法，然后通过这个方法就能通知到外部组件数据更新。
  change = (value: any) => {}; 

  // instanceId被更改走该方法
  set instanceId(value: string) { 
    this._data = value;
    // 将更新后的数据通知到外部组件
    this.change(this._data); 
  }

  // 页面或者方法里面有调用instanceId就会走该方法
  get instanceId() { 
    return this._data;
  }

  // 初始化时，获取并监听父组件通过ngModel传递进来的数据
  writeValue(val): void { 
    this._data = val;
    this.getData(val);
  }

  // 初始化后，执行该方法，并保存控件接收到 change 事件后，调用的函数
  registerOnChange(fn: any): void { 
    this.change = fn;
  }

  registerOnTouched(fn: any): void {
  }

  toggleDropBox(){
    if(this.disabledValue){
      return;
    }
    this.showDropBox = !this.showDropBox;
    if(this.showDropBox){
      setTimeout(()=>{
        $('#filter').focus();
      },0)
      this.filter = '';
      this.getData(this.selectNode.instanceId);
    }
  }

  // 清除选中项
  clear(){
    this.selectNode = {};
    this.instanceId = '';
  }

  // 选择某个实体
  selectItem(item){
    this.selectNode = item;
    this.instanceId = item.instanceId;
    this.showDropBox = false;
    // 抛出
    this.changeClick.emit({
      id: item.instanceId,
      text: item.instanceName
    });
  }

  // 查询实体列表数据
  getData(instanceId) {
    // 无默认值时根据概念查询列表
    if(!instanceId){
      this.selectNode = {}
      let instanceName = $.trim(this.filter);
      let Params = {
        current: 1,
        size: 30,
        instanceName:instanceName,
        conceptId: this.conceptId,
        isDelete: false
      };
      this.kmsService.getInstanceQueryList(Params).subscribe(
        data => {
          if (data.code == '200') {
              if (!data.data.records) {
                this.datas = [];
                return;
              }
              this.datas = data.data.records;
          }
        }
      );
    }
    // 有默认值时查询该条实体信息
    else{
      this.kmsService.getInstanceById(instanceId).subscribe(
        data => {
          if (data.code == '200') {
            if (!data.data) {
              this.datas = [];
              this.selectNode = {
                instanceId: instanceId
              };
              return;
            }
            this.datas = [data.data];
            this.selectNode = data.data;
          }
        }
      );
    }
  }

  // 添加实体
  add(){
    let instanceName = $.trim(this.filter);
    if(!instanceName){
      this.box.danger('请输入实体名称!');
      return;
    }
    if(!this.conceptId){
      this.box.danger('未指定所属概念信息！');
      return;
    }
    const userRole = this.jwt.getToken('userRole');
    // 获取概念信息
    this.kmsService.getConceptById(this.conceptId).subscribe(
      data => {
        if(data.code == '200'){
          this.kmsService.getInstanceMaxSerialNumber().subscribe(
            result => {
                if (result.code == '200') {
                  const serialNumber = result.data;
                  let params = {
                    currentUserRole: userRole == '知识编辑' ? 1 : 2,
                    serialNumber: serialNumber,
                    instanceId: this.instanceModuleService.uuid2(),
                    instanceName : instanceName,
                    conceptId: this.conceptId,
                    conceptCode: data.data.conceptCode,
                    conceptName: data.data.conceptName,
                    mapping: data.data.mapping,
                    attributes: [],
                    tags:[],
                    geoSaveList:[],
                    approvalStatus: 0
                  }
                  this.kmsService.saveInstanceUpdate(params).subscribe(
                    res => {
                      if(res.code == '200'){
                        this.box.success('保存成功!');
                        let item1 = res.data
                        this.selectItem(item1);
                        // 增量更新索引
                        this.updateIndex(item1.instanceId);
                      }else{
                        this.box.danger(res.msg);
                      }
                    }
                  )
                }
            }
          );
        }else{
          this.box.danger(data.msg);
        }
      }
    )
  }

  // 增量更新索引
  updateIndex(instanceId){
    this.kmsService.updateIndexByInstanceId(instanceId).subscribe(
        data => {
            if(data.code != '200'){
              console.log('索引更新失败!');
            }
        }
    )
  }

  // 查看实体详情
  queryDetail(instanceId){
    //禁止冒泡
    event.stopPropagation();

    let param = { instanceId: instanceId };
    this.create.createModal(InstanceInfoViewComponent, param)
  }
}
